// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stepId: __t.u64().primaryKey().name("step_id"),
  workspaceId: __t.u64().name("workspace_id"),
  roadId: __t.u64().name("road_id"),
  agendaId: __t.u64().name("agenda_id"),
  title: __t.string(),
  objective: __t.string(),
  status: __t.string(),
  orderIndex: __t.u32().name("order_index"),
  predecessorIdsJson: __t.string().name("predecessor_ids_json"),
  createdAt: __t.i64().name("created_at"),
  closedAt: __t.i64().name("closed_at"),
});
